<template>
  <div
    class="form-no-messages"
    style="position:relative"
  >
    <v-container>
      <div
        v-if="$store.getters.getMobileModel !== 'PDA'"
        class="qrcode-wrap"
        :style="{display: showQrScaner}"
      >
        <QrCodeScanComponent @scan-result="onPCodeScan" />
      </div>
      <div class="input-content-wrap">
        <v-row
          dense
          class="pb-0"
        >
          <v-col
            class="pb-0 pt-0"
            :class="{'pr-0': $store.getters.getMobileModel !== 'PDA' }"
            :cols="$store.getters.getMobileModel !== 'PDA' ? 7 : 8"
          >
            <v-autocomplete
              id="input-pcode"
              ref="refPcode"
              v-model="selectedPCode"
              :items="productionInfoList"
              label="품번"
              item-text="품번"
              item-value="품번"
              auto-select-first
              @change="onPCodeChange"
              @keyup.enter.prevent="onEnterPcode"
            />
          </v-col>
          <v-col
            v-if="$store.getters.getMobileModel !== 'PDA'"
            class="pb-0 pt-4 pl-0"
            cols="1"
          >
            <v-icon
              @click="showQrScaner = showQrScaner === 'none' ? 'block' : 'none'"
            >
              mdi-camera
            </v-icon>
          </v-col>
          <v-col
            class="pa-0"
            cols="4"
          >
            <v-dialog
              ref="dialog"
              v-model="modal"
              class="date-picker"
              :return-value.sync="selectedDate"
              :width="datePickerWidth"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDate"
                  label="발생일자"
                  readonly
                  v-bind="attrs"
                  autocomplete="off"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="selectedDate"
                locale="ko-ko"
                @input="onDateInput"
              />
            </v-dialog>
          </v-col>
        </v-row>
        <v-row class="pa-0">
          <v-col
            class="pb-0 pt-0"
            cols="6"
          >
            <v-autocomplete
              id="input-badType"
              v-model="selectedBadType"
              :items="badType"
              label="불량원인"
              item-text="코드명"
              item-value="코드"
              auto-select-first
              @change="onBadTypeChange"
            />
          </v-col>
          <v-col
            class="pb-0 pt-0"
            cols="6"
          >
            <v-text-field
              id="input-badOrReturnQty"
              v-model="badOrReturnQty"
              autocomplete="off"
              label="반품수량"
              placeholder="반품수량"
              type="number"
              clearable
              @keyup.enter.prevent="onEnterBadOrReturnQty"
            />
          </v-col>
        </v-row>
        <v-row class="pb-0">
          <v-col
            class="pb-0 pt-0"
            cols="6"
          >
            <v-text-field
              id="input-recycleQty"
              v-model="recycleQty"
              label="재투입수량"
              placeholder="수량"
              autocomplete="off"
              type="number"
              clearable
              @keyup.enter.prevent="onRecycleQty"
            />
          </v-col>
          <v-col
            class="pb-0 pt-0"
            cols="6"
          >
            <v-text-field
              id="input-confirmedQty"
              v-model="confirmedQty"
              label="폐기수량"
              autocomplete="off"
              readonly
              placeholder="수량"
              type="number"
              @keyup.enter.prevent="onClickSave"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-btn
              width="100%"
              color="primary"
              @click="onClickSave"
            >
              불량 내역 저장
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div style="margin-top:6px; background-color:black;">
        <dx-data-grid
          ref="refBadReceiptGrid"
          :data-source="badReceiptInfo"
          :show-borders="true"
          :show-row-lines="false"
          :show-column-lines="true"
          :hover-state-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :allow-column-reordering="true"
          :row-alternation-enabled="true"
          :height="gridHeightSub"
          :focused-row-enabled="true"
          key-expr="seqId"
          :focused-row-key.sync="focusedRowKey"
          @focused-row-changed="onSelectionChanged"
          @cell-prepared="onCellPreparedOutput"
          @toolbar-preparing="onToolbarPreparing"
          @row-removed="onRowRemoved"
        >
          <DxColumnFixing :enabled="true" />
          <DxEditing
            :allow-deleting="true"
            :allow-updating="false"
            :allow-adding="false"
            :use-icons="true"
            mode="row"
          />
          <DxColumn
            :allow-editing="false"
            caption="품번"
            data-field="품번"
            :fixed="false"
            :min-width="140"
            sort-order="asc"
          />
          <DxColumn
            :allow-editing="false"
            caption="수량"
            data-field="수량"
            :min-width="60"
            format="#,##0"
          />
          <DxColumn
            :allow-editing="false"
            caption="거래처"
            data-field="거래처명"
            :min-width="100"
          />
          <DxColumn
            :allow-editing="false"
            caption="품명"
            data-field="품명"
            :min-width="100"
          />
          <DxColumn
            width="50"
            :buttons="editButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format="#,##0"
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false" />
          <dx-scrolling
            mode="virtual"
          />
          <dx-sorting mode="multiple" />
          <template #grid-title>
            <div
              class="toolbar-label"
              style="font-size:1.1rem;margin-left:0px;"
            >
              <b>{{ selectedDate }} 불량품현황</b>
            </div>
          </template>
        </dx-data-grid>
      </div>
    </v-container>
  </div>
</template>
<script>
import AppLib from '../../share/AppLib'
import ConstDef from '../../../../MesSmartVue/src/share/ConstDef'
import DxDataGrid, { DxScrolling, DxColumn, DxPaging, DxSorting, DxColumnFixing, DxSummary, DxTotalItem, DxEditing } from 'devextreme-vue/data-grid'
import QrCodeScanComponent from '../../components/QrCodeScanComponent'

export default {
  name: 'BadReceipt',
  components: {
    DxScrolling,
    DxColumn,
    DxPaging,
    DxSorting,
    DxDataGrid,
    DxColumnFixing,
    DxSummary,
    DxTotalItem,
    DxEditing,
    QrCodeScanComponent
  },
  data: function () {
    return {
      badType: null,
      badOrReturnQty: null,
      confirmedQty: null,
      datePickerWidth: '350px',
      selectedBadType: null,
      selectedDate: AppLib.getToday(),
      recycleQty: null,
      modal: false,
      불량반품수량: '불량/반품수량',
      폐기반품수량: '폐기/반품수량',
      입고키: null,
      거래처코드: null,
      editButtons: ['delete'],
      // 추가
      // 기존
      isSaving: false,
      userInfo: null,
      selectedPCode: null,
      productionInfoList: [],
      selectedState: 0,
      processingLookup: [],
      divisionInfolist: [],
      companyInfoList: [],
      focusedRowKey: null,
      badReceiptInfo: null,
      gridHeightSub: null,
      selectedRow: null,
      // qrcode scan
      showQrScaner: 'none'
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.processingLookup = ConstDef.BAD_PROCESSING_STATE
    this.badType = this.$store.getters.getBaseDataByType(ConstDef.불량원인)
    this.productionInfoList = this.$store.getters.getGoodsList('ALL')
    this.refreshBadReceipt()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  updated () {
  },
  methods: {
    handleResize (e) {
      const drawContentHeight = this.$Q('.input-content-wrap').height()
      this.gridHeightSub = this.$Q('html').height() - drawContentHeight - 60
    },
    initInput () {
      this.selectedPCode = null
      this.badOrReturnQty = null
      this.recycleQty = null
      this.confirmedQty = null
      this.selectedBadType = null
      setTimeout(() => {
        this.$Q('#input-pcode').focus()
      }, 100)
    },
    getText (row) {
      return `${row.품번}`
    },
    onClickSave (e) {
      if (this.isSaving) return
      if (this.selectedPCode === null) {
        this.$snotify.error('품번을 선택하여 주세요')
        this.$Q('#input-pcode').click()
        return
      }
      if (this.selectedBadType === null) {
        this.$snotify.error('불량원인을 입력하여 주세요')
        this.$Q('#input-badType').click()
        return
      }
      if (this.badOrReturnQty === null) {
        this.$snotify.error('불량수량을 입력하여 주세요')
        this.$Q('#input-badOrReturnQty').focus()
        return
      }
      if (this.recycleQty === null) {
        this.$snotify.error('재투입수량을 입력하여 주세요')
        this.$Q('#input-recycleQty').focus()
        return
      }
      if (this.confirmedQty === null) {
        this.$snotify.error('폐기/반품수량을 확인하여 주세요')
        this.$Q('#input-confirmedQty').focus()
        return
      }
      this.isSaving = true
      let 폐기수량 = 0
      let 반품수량 = 0
      const result = this.$store.getters.getGoodsItemByGoodsNo(this.selectedPCode)
      if (result.품목유형 !== ConstDef.구매품) {
        폐기수량 = this.confirmedQty
      } else {
        반품수량 = this.confirmedQty
      }
      const param = [
        {
          입출고구분: ConstDef.반송입고,
          불량원인: this.selectedBadType,
          품번: this.selectedPCode,
          입고키: null,
          불량수량: 0,
          반송수량: this.badOrReturnQty,
          재투입수량: this.recycleQty,
          퍠기수량: 폐기수량,
          반품수량: 반품수량,
          거래처코드: this.거래처코드,
          장소위치코드: null,
          실적Key: null
        }
      ]
      this.$_sp.runUpdateProc('spSaveBadProduct', param)
        .then((data) => {
          this.isSaving = false
          this.refreshBadReceipt()
          this.initInput()
        })
        .catch(error => {
          this.isSaving = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onCellPreparedOutput (e) {
    },
    // Date 관련
    onDateInput (e) {
      this.$refs.dialog.save(this.selectedDate)
      this.refreshBadReceipt()
    },
    onBadTypeChange (e) {
      this.$Q('#input-badOrReturnQty').focus()
    },
    onEnterBadOrReturnQty (e) {
      if (this.badOrReturnQty !== null && this.badOrReturnQty.length > 0) {
        this.$Q('#input-recycleQty').focus()
      }
    },
    onRecycleQty (e) {
      if (this.recycleQty !== null && this.recycleQty.length > 0) {
        const badOrReturnQty = parseInt(this.badOrReturnQty)
        const recycleQty = parseInt(this.recycleQty)
        if ((this.badOrReturnQty === null || this.badOrReturnQty.length < 0) || badOrReturnQty < recycleQty) {
          this.$snotify.info('불량/반송수량을 정확히 입력하여 주세요.', { timeout: 700 })
          this.$Q('#input-badOrReturnQty').focus()
        } else {
          setTimeout(() => {
            this.confirmedQty = badOrReturnQty - recycleQty
            this.$Q('#input-confirmedQty').focus()
          }, 10)
        }
      }
    },
    onEnterPcode (e, pCode) {
      console.log('================', pCode)
      let split = null
      if (pCode === undefined) {
        split = this.$Q('#input-pcode').val()
      } else {
        split = pCode
      }
      split = AppLib.base64DecodeSubstring(split).split('/')
      this.selectedPCode = split[0].replace('?', ' ')
      const result = this.$store.getters.getGoodsItemByGoodsNo(this.selectedPCode)
      if (result === undefined) {
        this.$snotify.info('해당 품번이 존재하지않습니다.')
      } else {
        this.$Q('#input-badType').click()
      }
      this.onPCodeChange(this.selectedPCode)
    },
    onPCodeChange (pCode) {
      const result = this.$store.getters.getGoodsItemByGoodsNo(pCode)
      if (result.품목유형 === ConstDef.완제품) {
        this.거래처코드 = result.납품처코드
      } else {
        this.거래처코드 = result.거래처코드
      }
      setTimeout(() => {
        this.$Q('#input-badType').click()
        this.$Q('.v-autocomplete__content').css('display', 'none')
      }, 0)
    },
    onPCodeScan (result) {
      this.$Q('#input-pcode').val(result)
      this.onEnterPcode(null, result)
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('불량수불', [{ seqId: row.data.seqId }])
        .then((data) => {
          this.$snotify.info('삭제 되었습니다.', { timeout: 700 })
          this.initInput()
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onStateChange (e) {
      this.$Q('#input-division').focus()
    },
    onToolbarPreparing   (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'grid-title'
        }
      )
    },
    refreshBadReceipt () {
      const param = {
        발생일자: this.selectedDate,
        createid: this.userInfo.userId,
        입출고구분: ConstDef.반송입고
      }
      console.log(param)
      this.$_sp.runNoEncodeFindProc('spFindAllBadReceiptByDateAndRegIdAndType', param)
        .then((data) => {
          this.badReceiptInfo = this.$_sp.MakeModel(data)
          this.initInput()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
